module.exports = __webpack_public_path__ + "static/media/km.9b06043d.svg";